import { describeError } from '@cloudflare-monorepo/utils/errors';

interface ResponseErrorLike {
  response?: {
    status: number;
    json: () => Promise<unknown>;
  };
  data?: unknown;
}

interface ApplicationErrorBody {
  code?: string;
  error?: string;
}

export type ParsedRequestError = {
  applicationError: ApplicationErrorBody | null;
  isApplicationError: boolean;
  originalError: unknown;
  displayMessage: string;
  statusCode: number | null;
};

export const parseRequestError = async (err: unknown): Promise<ParsedRequestError> => {
  const asResponseError = err as ResponseErrorLike;
  const statusCode = asResponseError.response?.status ?? null;
  if (statusCode) {
    const body = (
      asResponseError.data !== undefined ? asResponseError.data : await asResponseError.response!.json()
    ) as ApplicationErrorBody;
    if (body.code?.length && body.error?.length) {
      return {
        isApplicationError: true,
        applicationError: body,
        originalError: err,
        displayMessage: body.error,
        statusCode,
      };
    }
    return {
      isApplicationError: false,
      applicationError: null,
      originalError: err,
      displayMessage: describeError(err),
      statusCode,
    };
  }
  return {
    isApplicationError: false,
    applicationError: null,
    originalError: err,
    displayMessage: describeError(err),
    statusCode: null,
  };
};
